import { toast } from "react-toastify";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const resetDemoStores = async () => {
  const resp = await api.post("/v2/intelligems/reset-demo-stores", {});
  return resp.data;
};

export const useResetDemoStores = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => resetDemoStores(),
    onSuccess: async (data) => {
      toast.success("Demo Stores Reset!");
      queryClient.clear();
    },
  });
};
